import { useState } from "react";
import { PageHeader } from "../../../components/PageHeader/index.js";
import BrokenAccountsTab from "./BrokenAccountsTab.js";
import OrphanedSubmissionsTab from "./OrphanedSubmissionsTab.js";
import styles from "./AccountRemediation.module.css";

type TabId = "broken" | "orphaned";

const TABS: ReadonlyArray<{ id: TabId; label: string }> = [
  { id: "broken", label: "Broken Accounts" },
  { id: "orphaned", label: "Orphaned Submissions" },
];

function AccountRemediationPage() {
  const [activeTab, setActiveTab] = useState<TabId>("broken");

  return (
    <div className={styles.wrapper}>
      <PageHeader
        title="Account Remediation"
        subtitle="Repair dangling orgs and reassign orphaned submissions"
      />

      <div className={styles.tabs}>
        {TABS.map(tab => (
          <button
            key={tab.id}
            type="button"
            className={activeTab === tab.id ? styles.tabActive : styles.tab}
            onClick={() => setActiveTab(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {activeTab === "broken" && <BrokenAccountsTab />}
      {activeTab === "orphaned" && <OrphanedSubmissionsTab />}
    </div>
  );
}

export default AccountRemediationPage;
